import GovWarningIcon from './GovWarningIcon';

export default GovWarningIcon;
